import React, { useState, FormEvent } from 'react';
import { useNavigate } from 'react-router-dom';
import {
    Button,
    Text,
    TextInput,
    PasswordInput,
    Title,
    Flex,
    Card
} from '@mantine/core';
import { login, saveToken } from '../service/authService';

const Login: React.FC = () => {
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [error, setError] = useState<string>('');
    const navigate = useNavigate();


    const handleSubmit = async (e: FormEvent<HTMLFormElement>) => {
        e.preventDefault();
        setError('');

        try {
            const loginResponse = await login(email, password);
            // If successful, server returns { jwt: "..." }
            saveToken(loginResponse.data.jwt);
            const returnUrl = localStorage.getItem('returnUrl');
            if (returnUrl) {
                // Clear it from localStorage so we don’t keep re-navigating
                localStorage.removeItem('returnUrl');
                // Then navigate back to invitation acceptance
                navigate(returnUrl);
            } else {
                // fallback
                navigate(returnUrl || '/');
            }
        } catch (err: any) {
            if (err.response && err.response.data && err.response.data.error) {
                setError(err.response.data.error);
            } else {
                setError('Anmelden fehlgeschlagen, bitte überprüfen Sie ihre Nutzerdaten.');
            }
        }
    };

    return (
        <Flex justify="center" align="center" h="100vh">
            <Flex align="flex-start" direction="column">
                <Title order={2} mb="md">
                    Anmeldung
                </Title>

                <Card w="400px" component="form" onSubmit={handleSubmit}>
                    {error && (
                        <Text color="red" mb="md">
                            {error}
                        </Text>
                    )}

                    <TextInput
                        label="E-Mail"
                        type="text"
                        value={email}
                        onChange={(event) => setEmail(event.currentTarget.value)}
                        required
                        mb="md"
                    />

                    <PasswordInput
                        label="Passwort"
                        value={password}
                        onChange={(event) => setPassword(event.currentTarget.value)}
                        required
                        mb="md"
                    />

                    <Flex w="100%" justify="flex-end" align="center" gap="5px">
                        <Button
                            p={0}
                            variant="transparent"
                            onClick={() => navigate('/request-password-reset')}
                        >
                            Passwort
                        </Button>
                        <Text>vergessen?</Text>
                        <Button ml="15px" type="submit" variant={"filled"}>
                            Anmelden
                        </Button>
                    </Flex>
                </Card>

                <Flex align="center" direction="row" mt="15px" gap="5px">
                    <Text>Noch keinen Account? Klicke</Text>
                    <Button p={0} variant="transparent" onClick={() => navigate('/register')}>
                        hier
                    </Button>
                    <Text>zum Registrieren</Text>
                </Flex>
            </Flex>
        </Flex>
    );
};

export default Login;
